import { Language } from '@nimbus-library/features/localization/models/enums/language.enum';

export const ADMIN_SUPPORTED_LANGUAGES: Language[] = [
  Language.English,
  Language.German,
  Language.French,
  Language.Italian,
  Language.Dutch,
  Language.Danish,
  Language.Spanish,
  Language.Swedish,
];
